
// This file was auto-generated by scripts/generate-icons-module.js
export const icons = {
	TPMS: 'TPMS',
	about: 'about',
	age_1_2: 'age-1-2',
	age_2_4: 'age-2-4',
	age_5_7: 'age-5-7',
	age_8_11: 'age-8-11',
	age_baby: 'age-baby',
	alert: 'alert',
	alert_outline: 'alert-outline',
	alignment: 'alignment',
	animal_rx: 'animal-rx',
	arrow_back: 'arrow-back',
	arrow_forward: 'arrow-forward',
	assembly: 'assembly',
	asterisk: 'asterisk',
	auto_drop_off: 'auto-drop-off',
	auto_wait_appt: 'auto-wait-appt',
	automotive_service: 'automotive-service',
	battery: 'battery',
	best_price: 'best-price',
	best_price_outline: 'best-price-outline',
	blain_eagle: 'blain-eagle',
	blain_eagle_lghead: 'blain-eagle-lghead',
	blain_eagle_outline: 'blain-eagle-outline',
	blainblog: 'blainblog',
	blainblog_outline: 'blainblog-outline',
	brakes: 'brakes',
	browse: 'browse',
	calendar: 'calendar',
	cart: 'cart',
	cart_outline: 'cart-outline',
	checkmark: 'checkmark',
	checkout: 'checkout',
	chevron_down: 'chevron-down',
	chevron_down_tiny: 'chevron-down-tiny',
	chevron_left: 'chevron-left',
	chevron_right: 'chevron-right',
	chevron_up: 'chevron-up',
	current_ad: 'current-ad',
	current_ad_NEW: 'current-ad-NEW',
	current_ad_outline: 'current-ad-outline',
	deal: 'deal',
	deal_fill: 'deal-fill',
	details: 'details',
	details_outline: 'details-outline',
	drag: 'drag',
	drive_thru: 'drive-thru',
	dtlist: 'dtlist',
	eagle_pin: 'eagle-pin',
	eagle_pin_outline: 'eagle-pin-outline',
	edit: 'edit',
	email: 'email',
	extended_service: 'extended-service',
	facebook: 'facebook',
	filter: 'filter',
	fishing: 'fishing',
	flannel_fest: 'flannel-fest',
	free_ship: 'free-ship',
	gift: 'gift',
	giftcard: 'giftcard',
	gps: 'gps',
	hamburger: 'hamburger',
	help: 'help',
	hide: 'hide',
	home: 'home',
	home_outline: 'home-outline',
	id: 'id',
	info_tiny: 'info-tiny',
	instagram: 'instagram',
	lightoff: 'lightoff',
	lighton: 'lighton',
	list: 'list',
	listBaby: 'listBaby',
	listCustom: 'listCustom',
	listShopping: 'listShopping',
	listWed: 'listWed',
	listWish: 'listWish',
	localdeliver: 'localdeliver',
	map: 'map',
	map_pin: 'map-pin',
	map_pin_outline: 'map-pin-outline',
	message: 'message',
	message_outline: 'message-outline',
	minus: 'minus',
	more: 'more',
	no_internet: 'no-internet',
	note: 'note',
	notification: 'notification',
	notification_outline: 'notification-outline',
	oil_change: 'oil-change',
	omni_shop: 'omni-shop',
	percent: 'percent',
	phone: 'phone',
	pinterest: 'pinterest',
	plus: 'plus',
	print: 'print',
	qr_code: 'qr-code',
	receipt: 'receipt',
	refresh: 'refresh',
	reg_edit: 'reg-edit',
	reg_create: 'reg_create',
	reglists: 'reglists',
	reglists_outline: 'reglists-outline',
	remove: 'remove',
	restrict: 'restrict',
	rewards_badge: 'rewards-badge',
	scan: 'scan',
	search: 'search',
	secure: 'secure',
	share: 'share',
	share_reg: 'share-reg',
	shield: 'shield',
	shield_outline: 'shield-outline',
	small_engine: 'small-engine',
	sort: 'sort',
	star: 'star',
	star_outline: 'star-outline',
	suspension: 'suspension',
	taxfree: 'taxfree',
	thumbs_down: 'thumbs-down',
	thumbs_up: 'thumbs-up',
	tire: 'tire',
	trash: 'trash',
	truck: 'truck',
	twitter: 'twitter',
	use_app: 'use-app',
	user: 'user',
	user_outline: 'user-outline',
	view: 'view',
	wishlist: 'wishlist',
	wrench: 'wrench',
	xmas: 'xmas',
	zoom: 'zoom'
} as const;

export type IconName = (typeof icons)[keyof typeof icons];

/**
 * Utility type for constraining a value to a limited subset of icons. Maintains type safety if icon names are changed or removed from IconName.
 * e.g. IconSubset<"auto-drop-off" | "auto-wait-appt"> is more type-safe than a simple union of "auto-drop-off" | "auto-wait-appt"
 */
export type IconSubset<Subset extends IconName> = Subset;
